import styled from "styled-components";

export const PreviewContainer = styled.div`
  /* Coach preview styles */
  .preview-coach-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
  }
  .preview-coach-header .ant-avatar {
    flex-shrink: 0;
  }
  .preview-coach-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .preview-coach-name {
    font-size: 22px;
    line-height: 32px;
    font-weight: 700;
    color: #3D3B48;
  }
  .preview-coach-info .link-icon {
    font-size: 16px;
    margin-right: 6px;
  }
  .preview-coach-subscribers {
    font-size: 16px;
    color: #547756;
  }
  .preview-coach-social-link {
    font-size: 16px;
    color: #3D3B48;
    margin-top: 4px;
    text-decoration: underline;
    cursor: pointer;
  }
  .preview-coach-social-link:hover {
    color: #547756;
  }
  .preview-coach-link {
    font-size: 16px;
    color: #3D3B48;
    margin-top: 4px;
  }
  .preview-about {
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    margin-top: 20px;
    color: #3D3B48;
  }
  .preview-coach-description {
    font-size: 16px;
    color: #3D3B48;
    line-height: 1.6;
    white-space: pre-line;
    word-wrap: break-word;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 20px;
  }

  /* Challenges section */
  .preview-coach-challenges {
    display: flex;
    margin-top: 10px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;
    gap: 12px;
    overflow-x: auto;
  }
  .preview-challenge-card {
    flex: 0 0 250px;
    width: 250px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
  }
  .preview-challenge-tag {
    width: fit-content;
    margin: 12px 12px 8px;
    border: 1px solid #547756 !important;
    color: #547756 !important;
  }
  .preview-challenge-title {
    font-weight: bold;
    color: #333;
    margin: 0 12px 12px;
    height: 40px;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .preview-challenge-banner {
    width: 100%;
    height: 120px;
    object-fit: cover;
    display: block;
  }
  .preview-challenge-description {
    font-size: 13px;
    color: #666;
    line-height: 1.5;
    padding: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    height: 75px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bold {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .fs-14 {
    font-size: 14px;
  }
`;

